import { Button } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

interface IResetButton {
  onClick: () => void;
  resetCategoryAriaText: string;
}

export const ResetButton = ({
  onClick,
  resetCategoryAriaText,
}: IResetButton) => (
  <Button
    sx={{
      height: '30px',
      fontSize: '16px',
      backgroundColor: 'transparent',
      alignSelf: 'end',
    }}
    variant='text'
    onClick={onClick}
    aria-describedby={resetCategoryAriaText}
  >
    {Dictionary[DICTIONARY.General].cancelChanges}
  </Button>
);
